import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import { default as ReactSelect } from "react-select";
import {getGoodsReceiptNoteReport,getGrnReportCSV,getGrnReportPDF} from "../../services/ReportServices";
import {  DatePicker } from 'antd';
import { getUserAllowedPlants} from '../../services/PlantServices';
import { getAllVendors } from "../../services/VendorServices";
import { getAllProducts } from "../../services/ProductServices";
import { getAllEquipments } from '../../services/EquipmentServices';
import { getCustomerVehicles } from '../../services/GoodsReceiptNoteServices';
import moment  from 'moment';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import {HandleSelect,ValueContainer,Option} from "../../components/MultiSelectControls";
import ReportExportDropdown from '../../components/ReportExportDropdown';
import ReportFilterToggleBar from '../../components/ReportFilterToggleBar';
import SettingsIcon from '../../components/SettingsIcon';
const {RangePicker} = DatePicker;

const GRN_REPORT_ALL_COLUMNS = [
    {
        fieldName: 'plant_alias',
        headerName: 'Plant',
        getCellStyle: (row) => (row.is_group_header ? { fontWeight: 'bold', color: '#1e3a8a' } : undefined),
    },
    { fieldName: 'goods_receipt_note_no', headerName: 'GRN No.' },
    { fieldName: 'goods_receipt_note_date', headerName: 'Date' },
    { fieldName: 'dc_no', headerName: 'DC No' },
    { fieldName: 'dc_dt', headerName: 'DC Dt' },
    { fieldName: 'in_time', headerName: 'In Time' },
    { fieldName: 'out_time', headerName: 'Out Time' },
    { fieldName: 'vendor_name', headerName: 'Vendor' },
    { fieldName: 'grade', headerName: 'Materials' },
    { fieldName: 'gross_weight', headerName: 'Gross Weight' },
    { fieldName: 'tare_weight', headerName: 'Tare Weight' },
    { fieldName: 'dc_qty', headerName: 'DC Qty' },
    { fieldName: 'grn_qty', headerName: 'Received Qty' },
    { fieldName: 'vehicle_no', headerName: 'Vehicle No' },
];

const GRN_CONDENSED_FIELDS = new Set([
    'plant_alias',
    'goods_receipt_note_no',
    'goods_receipt_note_date',
    'vendor_name',
    'grade',
    'dc_qty',
    'grn_qty',
    'vehicle_no',
]);

function GoodsReceiptNoteReport() 
{
    const InitialData = {
        records: []
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false);
    const [plants, setPlants] = React.useState([]);
    const [selectedPlant, setSelectedPlant] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState([]);
    const [vendors, setVendors] = React.useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState([]);
    const [grades, setGrades] = useState([]);
    const [inputs, setInputs] = useState({ report_format: 'all' });
    const [reportSettings, setReportSettings] = useState({ report_type: 'detailed' });
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [settingsDraft, setSettingsDraft] = useState({ report_type: 'detailed', selectedPlant: [] });
    const [totalGrnQty, setTotalGrnQty] = useState('0.00');
    const [totalDcQty, setTotalDcQty] = useState('0.00');
    const [filtersVisible, setFiltersVisible] = useState(true);

    // Initial state for from_date and to_date
    const initialFromDate = moment().startOf('month');
    const initialToDate =  moment();
    const [fromDate, setFromDate] = useState(initialFromDate);
    const [toDate, setToDate] = useState(initialToDate);
    const handleDateChange = (values) => {
        if ((values) && (values.length === 2)) {
        setFromDate(values[0]);
        setToDate(values[1]);
        }
    };

    React.useEffect(() => {
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                const plantOptions = plantList.plant_list.map(
                    plant => ({ value: plant.id, label: plant.plant_alias })
                );
                setPlants(plantOptions);
                setSelectedPlant([
                    { value: 'select-all', label: 'Select All plants' },
                    ...plantOptions,
                ]);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllVendors(cookies)
        .then (
            response => {
                const vendors = response.vendor_list.map(
                    vendor => {
                        return { value: vendor.id, label: vendor.entity_name }
                    }
                );
                setVendors(vendors);
                setSelectedVendor(values =>[...values,...vendors, ...vendorsWithSelectAll]);
            }
        )
    }, []);



    React.useEffect(() => {
        getCustomerVehicles(cookies)
        .then (
            response => {
                const customer_vehicles = response.customer_vehicles_list.map(
                    equip => {
                        return { value: equip, label: equip}
                    }
                );
                setVehicles(customer_vehicles);
                setSelectedVehicle(customer_vehicles);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllEquipments(cookies)
        .then (
            response => {
                const equipments = response.equipment_list.filter(obj => ((obj.equip_type.name === 'TRANSIT MIXER'))).map(
                    equipment => {
                        return { value: equipment.id, label: equipment.equip_name }
                    }
                );
                setVehicles(values =>[...values, ...equipments]);
                setSelectedVehicle(values =>[...values,...equipments, ...vehiclesWithSelectAll]);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllProducts(cookies)
        .then (
            productList => {
                const products = productList.product_list.map(
                    product => {
                        return { value: product.id, label: product.name}
                    }
                )
                setGrades(products);
                setSelectedGrade(values =>[...values,...products, ...gradesWithSelectAll]);
            }
        )
    }, []);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        console.log(name+value+"name and value")
        setInputs(values => ({...values, [name]: event.target.value}))
    }

    const plantsWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All plants" },
        ...plants,
    ]), [plants]);

    const vendorsWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All vendors" },
        ...vendors,
    ]), [vendors]);

    const vehiclesWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All vehicles" },
        ...vehicles,
    ]), [vehicles]);

    const gradesWithSelectAll = useMemo(() => ([
        { value: "select-all", label: "Select All grades" },
        ...grades,
    ]), [grades]);
      
    const onVendorSelect = (selected) => {
        HandleSelect(selected,selectedVendor, setSelectedVendor, vendors, vendorsWithSelectAll);
    };
        
    const onVehicleSelect = (selected) => {
        HandleSelect(selected,selectedVehicle, setSelectedVehicle, vehicles, vehiclesWithSelectAll);
    };
    
    const onGradeSelect = (selected) => {
        HandleSelect(selected,selectedGrade, setSelectedGrade, grades, gradesWithSelectAll);
    };

    const areAllPlantsSelected = () => {
        // Check if all plants are selected
        return plants.every((plant) =>
          selectedPlant ? selectedPlant.some((selected) => selected.value === plant.value) : false
        );
    };

    const areAllVendorsSelected = () => {
        // Check if all vendors are selected
        return vendors.every((vendor) =>
            selectedVendor ? selectedVendor.some((selected) => selected.value === vendor.value) : false
        );
    };

    const areAllVehiclesSelected = () => {
        // Check if all vehicles are selected
        return vehicles.every((vehicle) =>
        selectedVehicle ? selectedVehicle.some((selected) => selected.value === vehicle.value) : false
        );
    };
    
    const areAllGradesSelected = () => {
        // Check if all grades are selected
        return grades.every((grade) =>
        selectedGrade ? selectedGrade.some((selected) => selected.value === grade.value) : false
        );
    };

    const hasSelectedPlants = () => (
        areAllPlantsSelected()
        || selectedPlant.some((plant) => plant.value !== 'select-all')
    );

    const openReportSettings = () => {
        setSettingsDraft({
            report_type: reportSettings.report_type,
            selectedPlant: selectedPlant,
        });
        setShowSettingsModal(true);
    };

    const applyReportSettings = () => {
        const draftPlants = settingsDraft.selectedPlant || [];
        const hasPlants = draftPlants.some((plant) => plant.value === 'select-all')
            || draftPlants.some((plant) => plant.value !== 'select-all');
        if (!hasPlants) {
            Swal.fire('Please select at least one plant in report settings.', '', 'info');
            return;
        }
        setReportSettings({ report_type: settingsDraft.report_type });
        setSelectedPlant(draftPlants);
        setShowSettingsModal(false);
    };

    const onSettingsPlantSelect = (selected) => {
        HandleSelect(selected, settingsDraft.selectedPlant, (value) => {
            setSettingsDraft((current) => ({ ...current, selectedPlant: value }));
        }, plants, plantsWithSelectAll);
    };

    const Home = () => {
        navigate('/Home')
    }

    const mapGrnReportRow = (grn) => ({
        plant_name: grn.plant_name,
        plant_alias: grn.plant_alias,
        id: grn.id,
        goods_receipt_note_no: grn.goods_receipt_note_no,
        goods_receipt_note_date: grn.goods_receipt_note_date,
        dc_no: grn.dc_no,
        dc_dt: grn.dc_dt,
        in_time: grn.in_time,
        out_time: grn.out_time,
        vendor_name: grn.vendor_name,
        grade: grn.grade,
        gross_weight: grn.gross_weight,
        tare_weight: grn.tare_weight,
        dc_qty: grn.dc_qty,
        grn_qty: grn.grn_qty,
        vehicle_no: grn.vehicle_no,
    });

    const buildGroupedReportRows = (rows, reportFormat) => {
        if (reportFormat === 'all' || !rows.length) {
            return rows;
        }

        const groupConfig = {
            datewise: { key: 'goods_receipt_note_date', label: 'Date' },
            vendorwise: { key: 'vendor_name', label: 'Vendor' },
            productwise: { key: 'grade', label: 'Product' },
            gradewise: { key: 'grade', label: 'Product' },
        };
        const config = groupConfig[reportFormat];
        if (!config) {
            return rows;
        }

        const orderedKeys = [];
        const groups = new Map();

        rows.forEach((row) => {
            const key = row[config.key] || '-';
            if (!groups.has(key)) {
                groups.set(key, []);
                orderedKeys.push(key);
            }
            groups.get(key).push(row);
        });

        const groupedRows = [];
        orderedKeys.forEach((key) => {
            const groupRows = groups.get(key) || [];
            const groupQty = groupRows.reduce((sum, row) => sum + Number(row.grn_qty || 0), 0);
            groupedRows.push({
                id: `group-${config.label}-${key}`,
                is_group_header: true,
                plant_alias: `${config.label}: ${key}  |  Total Qty: ${groupQty.toFixed(2)}`,
            });
            groupedRows.push(...groupRows);
        });
        return groupedRows;
    };

    const columns = useMemo(() => {
        if (reportSettings.report_type === 'condensed') {
            return GRN_REPORT_ALL_COLUMNS.filter((col) => GRN_CONDENSED_FIELDS.has(col.fieldName));
        }
        return GRN_REPORT_ALL_COLUMNS;
    }, [reportSettings.report_type]);
   
    const handleCSVExport = (event) => {
    };

    const handlePDFExport = (event) => {
        // console.log('PDF Export');
    };

    const constructFormData = () => {
        const EMPTY_STRING = '';
        return {
            plant_ids:areAllPlantsSelected()? '*' // Send '*' if all plants are selected
            : selectedPlant.map((plant) => plant.value).join(','),
            vendor_ids:areAllVendorsSelected()? '*' // Send '*' if all vendors are selected
            : selectedVendor.map((vendor) => vendor.value).join(','),
            vehicle_ids:areAllVehiclesSelected()? '*' // Send '*' if all vehicles are selected
            : selectedVehicle.map((vehicle) => vehicle.value).join(','),
            product_ids:areAllGradesSelected()? '*' // Send '*' if all grades are selected
            : selectedGrade.map((grade) => grade.value).join(','),
            from_date:fromDate.format('DD-MM-YYYY'),
            upto_date:toDate.format('DD-MM-YYYY'),
            report_format:inputs.report_format,
            report_type: reportSettings.report_type || 'detailed',
          }
    }

    const handleGenerate = () => {
        const formData = constructFormData();
        if (!hasSelectedPlants()) {
            Swal.fire('Please select at least one plant in report settings.', '', 'info');
            return;
        }
        if ((formData.plant_ids) && (formData.vendor_ids) &&
        (formData.vehicle_ids) && (formData.product_ids) &&
        (formData.from_date) && (formData.upto_date) && (formData.report_format))
        {
            setIsLoading(true);
            getGoodsReceiptNoteReport(cookies, formData)
            .then(response => {
                const detailRows = (response.goods_receipt_note_report_list || []).map(mapGrnReportRow);
                const tableData = buildGroupedReportRows(detailRows, formData.report_format);
                setData({ records: tableData });
                const dcTotal = detailRows.reduce((sum, row) => sum + Number(row.dc_qty || 0), 0);
                setTotalGrnQty(Number(response.total_grn_qty || 0).toFixed(2));
                setTotalDcQty(dcTotal.toFixed(2));
                setFiltersVisible(false);
                setIsLoading(false);
            }).catch((error) => {
                console.log(error.response?.data);
                displayError(error.response?.data);
                setIsLoading(false);
            });
        }
        else
        {
            setData({ records: [] });
            setTotalGrnQty('0.00');
            setTotalDcQty('0.00');
            Swal.fire("plant,vendor,vehicle,product,from_date,upto_date,report format must not be empty.", "", "info");
        }
    };

    const handleSubmit=(event)=>
    {
        event.preventDefault();
        handleGenerate();
    }

        const handleDownloadPdf = () => {
            console.log(JSON.stringify(constructFormData())+"submit")
            const inputs = constructFormData();
            if (!hasSelectedPlants()) {
                Swal.fire('Please select at least one plant in report settings.', '', 'info');
                return;
            }
            setData({
                records: []
            });
            if ((inputs.plant_ids) && (inputs.vendor_ids) && 
            (inputs.vehicle_ids) && (inputs.product_ids) &&
            (inputs.from_date) && (inputs.upto_date))
            {
                getGrnReportPDF(cookies, constructFormData())
                .then(response => {
                    openPdfResponse(response, {
                        title: 'Goods Receipt Note Report',
                        downloadFileName: 'grn_report.pdf',
                    });
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error.response?.data);
                    displayError(error.response?.data);
                });
            }
            else 
            {
                Swal.fire("plant,vendor,vehicle,product,from_date,upto_date,report format must not be empty.", "", "info");  
            }
        };

        const handleDownloadCsv = () => {
            console.log(JSON.stringify(constructFormData())+"submit")
            const inputs = constructFormData();
            if (!hasSelectedPlants()) {
                Swal.fire('Please select at least one plant in report settings.', '', 'info');
                return;
            }
            setData({
                records: []
            });
            if ((inputs.plant_ids) && (inputs.vendor_ids) && 
        (inputs.vehicle_ids) && (inputs.product_ids) &&
        (inputs.from_date) && (inputs.upto_date))
            {
                getGrnReportCSV(cookies, constructFormData())
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'grn_report.csv');
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                })
                .catch((error) => {
                    console.log(error.response.data);
                    displayError(error.response.data);
                });
            }
            else 
            {
                Swal.fire("plant,vendor,vehicle,product,from_date,upto_date,report format must not be empty.", "", "info");  
            }
        };

    return (
            <div className="report-embedded-page">
                {!filtersVisible ? (
                    <div className="container">
                        <ReportFilterToggleBar onShow={() => setFiltersVisible(true)} />
                    </div>
                ) : null}
                {filtersVisible ? (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="container"> 
                       <Row> 
                            <Col xl={12} lg={12} md={12}>
                                <div className="report-legacy-filters form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                        <div className="report-legacy-filters-fields">
                                        <ReactSelect
                                            options={vendorsWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedVendor}
                                            onChange={onVendorSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please select Vendor"
                                        />
                                        <ReactSelect
                                            options={vehiclesWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedVehicle}
                                            onChange={onVehicleSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select Vehicle"
                                        />
                                        <ReactSelect
                                            options={gradesWithSelectAll}
                                            isMulti={true}
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{Option, ValueContainer}}
                                            isClearable={true}
                                            value={selectedGrade}
                                            onChange={onGradeSelect}
                                            className="react-select-dropdown col-sm-3"
                                            placeholder="Please Select Grade"
                                        />
                                        </div>
                                        <div className="report-legacy-filters-row">
                                        <RangePicker
                                            defaultValue={[initialFromDate, initialToDate]}
                                            format="DD-MM-YYYY"
                                            onChange={handleDateChange}
                                            style={{width:"270px"}}
                                        />
                                        <select
                                            className="browser-default custom-select col-sm-3"
                                            onChange={handleChange}
                                            value={inputs.report_format || 'all'}
                                            name="report_format"
                                            style={{width:"200px"}}
                                        >
                                            <option value="all">All</option>
                                            <option value="datewise">Datewise</option>
                                            <option value="vendorwise">Vendorwise</option>
                                            <option value="productwise">Productwise</option>
                                        </select>
                                        <div className="report-legacy-actions">
                                        <SettingsIcon onClickHandler={openReportSettings} variant="inline" />
                                        <ReportExportDropdown
                                            onCSV={handleDownloadCsv}
                                            onPDF={handleDownloadPdf}
                                            disabled={isLoading}
                                        />
                                        <Button
                                            color="primary"
                                            className="list-page-toolbar-generate-btn"
                                            type="button"
                                            onClick={handleGenerate}
                                            disabled={isLoading}
                                        >
                                            Generate
                                        </Button>
                                        </div>
                                        </div>
                                </div>
                             </Col>
                        </Row>
                    </div> 
                </form>
                ) : null}
                <Modal isOpen={showSettingsModal} toggle={() => setShowSettingsModal(false)} centered>
                    <ModalHeader toggle={() => setShowSettingsModal(false)}>Report Settings</ModalHeader>
                    <ModalBody>
                        <div className="mb-3">
                            <label className="font-weight-bold d-block mb-2">Plant</label>
                            <ReactSelect
                                options={plantsWithSelectAll}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                components={{ Option, ValueContainer }}
                                isClearable={true}
                                value={settingsDraft.selectedPlant}
                                onChange={onSettingsPlantSelect}
                                className="react-select-dropdown"
                                placeholder="Please select Plant"
                            />
                        </div>
                        <div>
                            <label className="font-weight-bold d-block mb-2">Report Type</label>
                            <select
                                className="browser-default custom-select"
                                value={settingsDraft.report_type}
                                onChange={(event) => setSettingsDraft((current) => ({
                                    ...current,
                                    report_type: event.target.value,
                                }))}
                            >
                                <option value="detailed">Detailed</option>
                                <option value="condensed">Condensed</option>
                            </select>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => setShowSettingsModal(false)}>Cancel</Button>
                        <Button color="primary" onClick={applyReportSettings}>Apply</Button>
                    </ModalFooter>
                </Modal>
                <div className="container">
                        {data.records.length > 0 ? (
                                <div className="list-page-summary-bar">
                                    <div className="list-page-summary-primary">
                                        <span className="list-page-summary-label">FILTERED VIEW</span>
                                        <span className="list-page-summary-count">
                                            {data.records.filter((row) => !row.is_group_header).length}{' '}
                                            {data.records.filter((row) => !row.is_group_header).length === 1 ? 'record' : 'records'}
                                        </span>
                                    </div>
                                    <div className="list-page-summary-metrics">
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Total GRN Qty</span>
                                            <span className="list-page-metric-value is-yellow">{totalGrnQty}</span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Total DC Qty</span>
                                            <span className="list-page-metric-value">{totalDcQty}</span>
                                        </div>
                                        <div className="list-page-metric-card">
                                            <span className="list-page-metric-label">Receipts</span>
                                            <span className="list-page-metric-value is-b2b">
                                                {data.records.filter((row) => !row.is_group_header).length}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                        ) : null}
                    <div className="list-page-table-wrap">
                        <div className="item-list-table-container">
                            <div className="table-responsive">
                                <ReactTableWrapper
                                    title='Goods Receipt Note Report'
                                    columns={columns}
                                    data={data.records}
                                    exportFilename="goods_receipt_note_report"
                                    enableTableSearch={false}
                                    enableExportToolbar={false}
                                    isLoading={isLoading}
                                    getRowSx={(row) => (
                                        row.is_group_header
                                            ? {
                                                backgroundColor: '#dbeafe !important',
                                                '&:hover': { backgroundColor: '#bfdbfe !important' },
                                                '& td': { borderTop: '2px solid #2563eb' },
                                            }
                                            : {}
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
);
}

export default GoodsReceiptNoteReport;